import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import mountApp from './mountApp';
import reportWebVitals from './reportWebVitals';
import 'firebaseui/dist/firebaseui.css';

// Marketing routes ship as prerendered HTML (scripts/prerender.js) so non-JS
// crawlers can read them; app routes ship as the empty CRA shell. mountApp
// picks hydrate vs. render from what is actually in #root.
// The flag is the build's only proof that JS actually ran: scripts/prerender.js
// waits for it to be `true`, which fails if the bundle 404s, throws before
// mounting, or regresses to createRoot and throws the snapshot away.
window.__PRERENDER_HYDRATED__ = mountApp(
  document.getElementById('root'),
  (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ),
  { createRoot, hydrateRoot }
).hydrated;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
